import SDKAdapter from '../../core/adapter.js';
import { SDKModel } from '../../core/model.js';
import { ExternalComponentModel } from './external-components.js';
export class Forms extends SDKAdapter {
    async fetch() {
        return this.search();
    }
    /** Searches for tenants through inventory api request */
    async search() {
        let siteName;
        try {
            siteName = new URL(window.location.href).searchParams.get('sc_site');
        }
        catch (_a) {
            console.error('FEAAS: could not find current location');
        }
        const response = (await this.sdk.fetchJSON(`${this.sdk.formsBackend.replace('{region}', this.sdk.auth.tenant.getRegionCode())}/api/entities/filter`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${this.sdk.accessToken}`
            },
            cache: 'no-cache',
            body: JSON.stringify({
                Page: 1,
                PageSize: 1000,
                WhereEntityStatus: 1,
                SiteNames: siteName ? [siteName] : undefined
            })
        }));
        return response === null || response === void 0 ? void 0 : response.Items.map((item) => ({
            id: item.Entity.Id,
            name: item.Entity.Name,
            thumbnail: item.PreviewImageUrl
        }));
    }
}
export class FormModel extends SDKModel {
    constructor(data) {
        super(data);
        this.updateFormsOnSitecoreSiteChange();
    }
    get adapter() {
        return this.sdk.Forms;
    }
    /**
     * Add a listener to fetch forms based on site name every time the site changes
     */
    updateFormsOnSitecoreSiteChange() {
        //@ts-ignore
        if (typeof window !== 'undefined' && !window.hasSitecoreSiteChangeObserver) {
            let oldSite = new URL(window.location.href).searchParams.get('sc_site');
            let observer = new MutationObserver(() => {
                let newSite = new URL(window.location.href).searchParams.get('sc_site');
                if (oldSite !== newSite) {
                    oldSite = newSite;
                    this.fetch().then((forms) => {
                        FormModel.onCollectionChange(forms);
                    });
                }
            });
            observer.observe(document, { subtree: true, childList: true });
            // @ts-ignore
            window.hasSitecoreSiteChangeObserver = true;
        }
    }
    static onCollectionChange(forms) {
        ExternalComponentModel.setForms(forms);
        ExternalComponentModel.updateComponents(forms.construct().sdk.renderingHost.registeredComponents, forms.construct().sdk.renderingHost.expandedComponents);
        return forms;
    }
}
//# sourceMappingURL=forms.js.map